import { ReactNode, useState } from 'react';
import { View } from 'react-native';
import { Gesture, GestureDetector } from 'react-native-gesture-handler';

type SinglePressBtn = {
  onPress: () => void;
};

type LongPressBtn = {
  onPressIn: () => void;
  onPressOut: () => void;
};

type Props = {
  children: ReactNode;
  isDisabled?: boolean;
} & (SinglePressBtn | LongPressBtn);

export const GestureButton = ({ children, isDisabled, ...props }: Props) => {
  const [longPressed, setLongPressed] = useState(false);
  const isSinglePress = 'onPress' in props;

  const pressGesture = Gesture.Tap()
    .runOnJS(true)
    .onBegin(() => isSinglePress && props.onPress())
    .enabled(!isDisabled);

  const longPressGesture = Gesture.LongPress()
    .runOnJS(true)
    .onBegin(() => {
      setLongPressed(true);
      !isSinglePress && props.onPressIn();
    })
    .onStart(() => !isSinglePress && props.onPressIn())
    .onEnd(() => !isSinglePress && props.onPressOut())
    .onTouchesUp(({ numberOfTouches }) => {
      if (numberOfTouches > 0) {
        return;
      }
      !isSinglePress && props.onPressOut();
      setLongPressed(false);
    })
    .onTouchesCancelled((e) => {
      !isSinglePress && props.onPressOut();
      setLongPressed(false);
    })
    .maxDistance(200)
    .enabled(!isDisabled);

  const activeGesture = isSinglePress ? pressGesture : longPressGesture;
  const disabledStyles = isDisabled ? 'opacity-40' : undefined;
  const pressedStyles = longPressed ? 'opacity-60' : undefined;

  return (
    <GestureDetector gesture={activeGesture}>
      <View className={disabledStyles || pressedStyles}>{children}</View>
    </GestureDetector>
  );
};
